import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("../index/index.module").then((m) => m.IndexModule),
  },
  {
    path: "portal",
    loadChildren: () => import("../portal/portal.module").then((m) => m.PortalModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
